import React, { useState } from "react";
import { Modal, Button, Checkbox, Table } from "antd";
import dayjs from "dayjs";
import { useProjectState } from "../../../context/stateContext";
import "./index.css";

const WaiterInfoModal = ({ record }) => {
  const [showPayMethods, setShowPayMethods] = useState(false);
  const { showWaiterSalesDetails, setShowWaiterSalesDetails } =
    useProjectState();

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      rowKey: "date",
      width: "40%",
      sorter: (a, b) =>
        dayjs(a.date)
          .format("YYYY-MM-DD")
          .localeCompare(dayjs(b.date).format("YYYY-MM-DD")),
      key: "date",
      render: (date) => (
        <span className="waiters-info-table-text">
          {dayjs(date).format("YYYY-MM-DD")}
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div style={{ whiteSpace: "nowrap" }}>
            Общо{" "}
            {record
              .reduce((accumulator, currentValue) => {
                return accumulator + currentValue.total;
              }, 0)
              .toFixed(2)}
          </div>
        );
      },
      dataIndex: "total",
      rowKey: "total",
      width: "15%",
      sorter: (a, b) => a.total - b.total,
      align: "center",
      key: "total",

      render: (total) => (
        <span className="waiters-info-table-text">{total.toFixed(2)}</span>
      ),
    },
  ];

  if (showPayMethods) {
    columns.splice(1, 0, {
      title: "Други",
      dataIndex: "other",
      rowKey: "other",
      width: "15%",
      sorter: (a, b) => a.other - b.other,
      align: "center",
      key: "other",

      render: (other) => (
        <span className="waiters-info-table-text">{other.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: "Карта",
      dataIndex: "card",
      rowKey: "card",
      width: "15%",
      sorter: (a, b) => a.card - b.card,
      align: "center",
      key: "card",

      render: (card) => (
        <span className="waiters-info-table-text">{card.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: "Брой",
      dataIndex: "cash",
      rowKey: "cash",
      width: "15%",
      sorter: (a, b) => a.cash - b.cash,
      align: "center",
      key: "cash",

      render: (cash) => (
        <span className="waiters-info-table-text">{cash.toFixed(2)}</span>
      ),
    });
  }

  return (
    record.length !== 0 && (
      <Modal
        className="waiter-info-modal"
        centered
        width={"650px"}
        cancelButtonProps={{ style: { display: "none" } }}
        open={showWaiterSalesDetails}
        bodyStyle={{ height: "auto" }}
        footer={null}
        onCancel={() => setShowWaiterSalesDetails(!showWaiterSalesDetails)}
      >
        <div className="waiter-info-header-modal-container">
          <p className="waiter-info-header-modal-waiter-name">
            Сервитьор: {record[0].waiterName}
          </p>
          <div className="waiter-info-modal-header-secondary-container">
            <Checkbox
              checked={showPayMethods}
              onChange={() => setShowPayMethods(!showPayMethods)}
            >
              <p className="waiters-checkbox-text">Видове Плащания</p>
            </Checkbox>
          </div>
        </div>

        <div className="waiters-info-table-container">
          <Table
            rowKey="total"
            dataSource={record}
            columns={columns}
            pagination={false}
            className="waiters-info-table"
          />
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            onClick={() => setShowWaiterSalesDetails(!showWaiterSalesDetails)}
          >
            Затвори
          </Button>
        </div>
      </Modal>
    )
  );
};

export default WaiterInfoModal;
